import dayjs from "dayjs";
import { useEffect } from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import { useAtom } from "jotai";
import { userAtom, userJwtAtom } from "./services/atoms";
import { fetchDB, useQuery } from "./services/hooks";

var utc = require("dayjs/plugin/utc");

dayjs.extend(utc);


const Comments = {
  comments: [`comments_with_articles?moderated=eq.0`, true],
}

const EditComment = ({ initial, accept }) => {
  const [content, setContent] = useState(false);
  return (
    <>
      <textarea
        className="w-full"
        rows="6"
        value={content || initial}
        onChange={(e) => setContent(e.target.value)}
      />
      <button onClick={() => accept(content || initial)}>Save</button>
    </>
  );
};
export default () => {
  const [user] = useAtom(userJwtAtom);
  const [{ data, error }, refetchComments] = useQuery({
    query: Comments,
  });


  const editComment = async (id, data) => {
    await fetchDB(`comments?id=eq.${id}`, 'PATCH', data)
  }

  useEffect(() => {
    setInterval(() => {
      console.log("refetch");
      refetchComments();
    }, 3000);
  }, []);

  if (!data) return <div>Ładowanie...</div>;
  return (
    <div>
      <Link to="/commentsModerated">ZMODEROWANE</Link>
      <br />
      <br />
      {data.comments.length === 0 && (
        <div>Wszystkie komentarze zmoderowane, jesteście zajebiści! :)</div>
      )}
      {data.comments.map((comment) => (
        <div>
          Data: {dayjs.utc(comment.created_at).format("YYYY-MM-DD HH:mm")}
          <br />
          Nick: {comment.nick}
          <br />
          IP: {comment.ip}
          <br />
          <a target="_blank" href={`https://histmag.org/?id=${comment.post}`}>
            {comment.title}
          </a>
          <br />
          Content:{" "}
          <EditComment
            accept={(content) =>
              editComment(comment.id, {
                content,
              })
            }
            initial={comment.content}
          />
          <br />
          <br />
          <button
            className="border-2 p-4 mr-8"
            onClick={() =>
              editComment(comment.id, {
                shown: 1,
                moderated: true,
                moderated_by: user.id,
              })
            }
          >
            OK
          </button>
          <button
            className="border-2 p-4"
            onClick={() =>
              editComment(comment.id, {
                shown: 0,
                moderated: true,
                moderated_by: user.id,
              })
            }
          >
            wywalić
          </button>
          <br />
          <br />
          <hr />
          <br />
        </div>
      ))}
    </div>
  );
};
